function loadScript(url, id) {
  return new Promise((resolve) => {
    if (document.getElementById(id)) {
      resolve(true);
      return;
    }
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.id = id;
    let timer = window.setTimeout(function() {
      timer = null;
      resolve(false);
    }, 1e4);
    script.onload = function() {
      if (timer) {
        clearTimeout(timer);
        resolve(true);
      }
    };
    script.src = url;
    document.body.appendChild(script);
  });
}
function throttle(fn, wait, { leading, trailing } = { leading: true, trailing: true }) {
  let timeout = null;
  let previous = 0;
  return function(...args) {
    const now = Date.now();
    if (leading === false) previous = now;
    const remaining = wait - (now - previous);
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      fn.apply(this, args);
    } else if (!timeout && trailing !== false) {
      timeout = window.setTimeout(() => {
        previous = leading === false ? 0 : Date.now();
        timeout = null;
        fn.apply(this, args);
      }, remaining);
    }
  };
}
function debounce(callback, wait) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = window.setTimeout(() => {
      callback.apply(this, args);
    }, wait);
  };
}
function number2text(number, type = "upper") {
  const confs = {
    lower: {
      num: ["\u96F6", "\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D", "\u4E03", "\u516B", "\u4E5D"],
      unit: ["", "\u5341", "\u767E", "\u5343", "\u4E07"],
      level: ["", "\u4E07", "\u4EBF"]
    },
    upper: {
      num: ["\u96F6", "\u58F9", "\u8D30", "\u53C1", "\u8086", "\u4F0D", "\u9646", "\u67D2", "\u634C", "\u7396"],
      unit: ["", "\u62FE", "\u4F70", "\u4EDF"],
      level: ["", "\u4E07", "\u4EBF"]
    },
    decimal: {
      unit: ["\u5206", "\u89D2"]
    },
    maxNumber: 99999999999999e-2
  };
  if (Number(number) > confs.maxNumber) {
    return "";
  }
  const conf = confs[type];
  const numbers = String(Number(number).toFixed(2)).split(".");
  const integer = numbers[0].split("");
  const decimal = Number(numbers[1]) === 0 ? [] : numbers[1].split("");
  const levels = integer.reverse().reduce((pre, item, idx) => {
    const level = pre[0] && pre[0].length < 4 ? pre[0] : [];
    const value = item === "0" ? conf.num[item] : conf.num[item] + conf.unit[idx % 4];
    level.unshift(value);
    if (level.length === 1) {
      pre.unshift(level);
    } else {
      pre[0] = level;
    }
    return pre;
  }, []);
  const _integer = levels.reduce((pre, item, idx) => {
    let _level = conf.level[levels.length - idx - 1];
    let _item = item.join("").replace(/(零)\1+/g, "$1");
    if (_item === "\u96F6") {
      _item = "";
      _level = "";
    } else if (_item[_item.length - 1] === "\u96F6") {
      _item = _item.slice(0, _item.length - 1);
    }
    return pre + _item + _level;
  }, "");
  const _decimal = decimal.map((item, idx) => {
    const unit = confs.decimal.unit;
    const _unit = item !== "0" ? unit[unit.length - idx - 1] : "";
    return `${conf.num[item]}${_unit}`;
  }).join("");
  return `${_integer}\u5143` + (_decimal || "\u6574");
}
function setObjectProperty(object, path, value) {
  if (!path) {
    throw "path \u5C5E\u6027\u8DEF\u5F84\u4E0A\u7684\u503C\u4E0D\u80FD\u4E3A\u7A7A";
  } else if (!object || typeof object !== "object") {
    throw "\u8BBE\u7F6E\u7684\u76EE\u6807\u5FC5\u987B\u662F\u5BF9\u8C61\u7C7B\u578B";
  }
  let keyArray = [];
  if (typeof path === "string") {
    path = path.replace(/\[(\w+)\]/g, ".$1");
    path = path.replace(/^\./, "");
    keyArray = path.split(".");
  } else if (Array.isArray(path)) {
    keyArray = path;
  } else {
    throw "path \u5C5E\u6027\u8DEF\u5F84\u53EA\u80FD\u4E3A\u5B57\u7B26\u4E32\u7C7B\u578B\u6216\u6570\u7EC4\u7C7B\u578B";
  }
  if (keyArray.length === 1) {
    object[keyArray[0]] = value;
    return { rootObject: { [keyArray[0]]: value } };
  }
  const getValue = function(targetObject, key, isArray) {
    let value2 = targetObject[key];
    if (value2 === void 0 || value2 === null || typeof value2 !== "object") {
      targetObject[key] = value2 = isArray ? [] : {};
    }
    return value2;
  };
  let targetValue = getValue(object, keyArray[0], /^\d+$/.test(keyArray[1]));
  const rootName = keyArray[0];
  const rootValue = targetValue;
  for (let i = 1; i < keyArray.length - 1; i++) {
    targetValue = getValue(targetValue, keyArray[i], /^\d+$/.test(keyArray[i + 1]));
  }
  targetValue[keyArray[keyArray.length - 1]] = value;
  return { rootObject: { [rootName]: rootValue } };
}
function getObjectProperty(object, path, defaultValue) {
  if (!path) {
    throw "path \u5C5E\u6027\u8DEF\u5F84\u4E0A\u7684\u503C\u4E0D\u80FD\u4E3A\u7A7A";
  } else if (!object || typeof object !== "object") {
    throw "\u8BBE\u7F6E\u7684\u76EE\u6807\u5FC5\u987B\u662F\u5BF9\u8C61\u7C7B\u578B";
  }
  let keyArray = [];
  if (typeof path === "string") {
    path = path.replace(/\[(\w+)\]/g, ".$1");
    path = path.replace(/^\./, "");
    keyArray = path.split(".");
  } else if (path instanceof Array) {
    keyArray = path;
  } else {
    throw "path \u5C5E\u6027\u8DEF\u5F84\u53EA\u80FD\u4E3A\u5B57\u7B26\u4E32\u7C7B\u578B\u6216\u6570\u7EC4\u7C7B\u578B";
  }
  let targetValue = object;
  for (let i = 0; i < keyArray.length; i++) {
    if (Object.prototype.hasOwnProperty.call(targetValue, keyArray[i])) {
      targetValue = targetValue[keyArray[i]];
      if (targetValue === null) return null;
    } else {
      targetValue = void 0;
    }
    if (targetValue === void 0) {
      return defaultValue;
    }
  }
  return targetValue;
}

export { debounce, getObjectProperty, loadScript, number2text, setObjectProperty, throttle };
//# sourceMappingURL=others.mjs.map
